// extracted by mini-css-extract-plugin
export default {"page":"LoginAsNotice_page__ds6Wn","message":"LoginAsNotice_message__qJUCL"};